import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
import { SmartModalService, ModalSize } from 'app/core/services/smart-modal.service';
import { RateProductComponent } from 'app/shared/components/modal/rate-product/rate-product.component';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';
import { NotificationService } from 'app/core/services/notification.service';

declare var $;

@Component({
  selector: 'itpx-card-details-presentation',
  templateUrl: './card-details-presentation.component.html',
  styleUrls: ['../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardDetailsPresentationComponent implements OnInit {

  @Input() platformClass: any;
  @Input() conf: CardConfiguration;
  private tagType: string;
  private expired: boolean;
  private linkActions = LinkActions;
  private starColor;
  private createReviewUrl: string;
  private loading: boolean = false;

  starsCount: number = 0; // this will come from product info
  range = [1, 2, 3, 4, 5];
  currentReview: any = {};

  constructor(private router: Router,
    private route: ActivatedRoute, private modalService: SmartModalService, private configService: ConfigService,
    private requestService: RequestService, private detector: ChangeDetectorRef, private notifService: NotificationService) {

  }

  ngOnInit() {
    // console.log(this.platformClass);
    this.starColor = this.platformClass.status === 'Consumed' ? 'orange' : 'grey';
    this.createReviewUrl = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.review.create.api;
    this.currentReview = this.platformClass.review ? this.platformClass.review : {};
    this.starsCount = this.currentReview.rating ? this.currentReview.rating : 0;
    // console.log(this.conf);
    Object.assign(this, this.conf);
  }

  // TODO: info should come from the backend"
  voucherExpired(course: any): boolean {
    let d = new Date(course.createdAt);
    let expiryDate = new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());
    return expiryDate < new Date();
  }


  trackByFn(index, item) {
    return index; // or item.id
  }

  public isMarked = (index) => {

    if (this.starsCount >= index + 1) {
      return 'fa-star';
    }
    else if (this.starsCount > index && this.starsCount < index + 1) {
      return 'fa-star-half-o';
    }
    else {
      return 'fa-star-o';
    }

  }

  openRateModal(event) {
    event.preventDefault();
    event.stopPropagation();
    this.modalService.open(RateProductComponent, {review:this.currentReview,productName:this.platformClass.name}, "Review Product", ModalSize.Md).neverError()
      .subscribe(r => {
        // console.log(r);
        if (r) {
          this.requestService.post(this.createReviewUrl,
            { rating: r.result.rating, anonymize: r.result.anonymize, assignmentId: this.platformClass.type==='consumable' ? this.platformClass.assignmentId : this.platformClass.id, reviewText: r.result.review }
          ).subscribe(r => {
            if(r)
              this.notifService.success('Review added'); 
          });
          this.currentReview={rating: r.result.rating, anonymize: r.result.anonymize, assignmentId: this.platformClass.id, reviewText: r.result.review};
          this.starsCount=r.result.rating;
          this.detector.detectChanges();
          
          // console.log(r);
        }
      });;

  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/card-details-presentation/card-details-presentation.component.ts